// Messages for operator/Search (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.search.head': 'Search — Operator',
  'operator.search.title': 'Search',
  'operator.search.placeholder': 'Customers, carriers…',
  'operator.search.submit': 'Search',
  'operator.search.recent': 'Recent: ',
  'operator.search.no_matches': 'No matches.',
  'operator.search.po': 'PO',
  'operator.search.container': 'Container',
}

export const zhTW = {
  'operator.search.head': '搜尋 — 操作端',
  'operator.search.title': '搜尋',
  'operator.search.placeholder': '客戶、承運商…',
  'operator.search.submit': '搜尋',
  'operator.search.recent': '最近搜尋：',
  'operator.search.no_matches': '沒有符合的結果。',
  'operator.search.po': '採購單',
  'operator.search.container': '貨櫃',
}
